import { render, staticRenderFns } from "./BattleUser.vue?vue&type=template&id=029dba9d&"
import script from "./BattleUser.vue?vue&type=script&lang=ts&"
export * from "./BattleUser.vue?vue&type=script&lang=ts&"
import style0 from "./BattleUser.vue?vue&type=style&index=0&id=029dba9d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports